import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './HeroVisual.css';

const Blob = ({ className, x, y, duration, delay = 0 }) => (
  <motion.div
    className={className}
    animate={{
      x: [0, x, 0],
      y: [0, y, 0],
    }}
    transition={{
      duration,
      delay,
      repeat: Infinity,
      ease: 'easeInOut',
    }}
  />
);

const HeroVisual = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });

  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.15]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.25]);
  const yFar = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const yNear = useTransform(scrollYProgress, [0, 1], [0, -80]);

  return (
    <div className="hero-visual" ref={ref} aria-hidden="true">
      <motion.div className="hero-visual-field" style={{ opacity, scale }}>
        <Blob className="hero-blob hero-blob--orange" x={40} y={-30} duration={14} />
        <Blob className="hero-blob hero-blob--navy" x={-50} y={40} duration={18} delay={1} />
        <Blob className="hero-blob hero-blob--steel" x={30} y={50} duration={16} delay={2} />
      </motion.div>

      <motion.svg
        className="hero-visual-rings"
        style={{ y: yFar }}
        viewBox="0 0 600 600"
        animate={{ rotate: 360 }}
        transition={{ duration: 90, repeat: Infinity, ease: 'linear' }}
      >
        <circle cx="300" cy="300" r="280" className="ring ring--orange" />
        <circle cx="300" cy="300" r="230" className="ring ring--steel" />
      </motion.svg>

      <motion.div className="hero-visual-dots" style={{ y: yNear }}>
        {Array.from({ length: 14 }).map((_, i) => (
          <span key={i} className="hero-dot" style={{ '--i': i }} />
        ))}
      </motion.div>
    </div>
  );
};

export default HeroVisual;
